import { createPage } from '../../shared/create-page'

// ============================================
// COMPANY MANAGER
// ============================================

export const DashboardPage = createPage(
  () => import('@pages/backoffice/company-manager/dashboard/dashboard-page')
)

export const CreateUserProfilePage = createPage(
  () => import('@pages/backoffice/company-manager/collaborators/create/create-user-profile-page')
)

export const EditUserProfilePage = createPage(
  () => import('@pages/backoffice/company-manager/collaborators/edit/edit-user-profile-page')
)

export const DependentHolderSearchPage = createPage(
  () =>
    import('@pages/backoffice/company-manager/dependent/dependent-mgmt-users/holder-search-page')
)

export const DependentRegistrationPage = createPage(
  () =>
    import(
      '@pages/backoffice/company-manager/dependent/dependent-mgmt-users/dependent-registration-page'
    )
)

export const DependentSearchPage = createPage(
  () =>
    import('@pages/backoffice/company-manager/dependent/dependent-mgmt-users/dependent-search-page')
)

export const RequestsConfigurationPage = createPage(
  () =>
    import(
      '@pages/backoffice/company-manager/requests/requests-configuration/requests-configuration-page'
    )
)

export const DependentEnrollmentPage = createPage(
  () =>
    import(
      '@pages/backoffice/company-manager/dependent/dependent-enrollment/dependent-enrollment-page'
    )
)

export const UpgradeEnrollmentPage = createPage(
  () =>
    import('@pages/backoffice/company-manager/upgrade/upgrade-enrollment/upgrade-enrollment-page')
)

export const AuthorizationPage = createPage(
  () => import('@pages/backoffice/company-manager/authorization/list/authorization-page')
)

export const ScholarshipRenewalPage = createPage(
  () => import('@pages/backoffice/company-manager/scholarship-renewal/scholarship-renewal-page')
)

export const AuthorizationDetailPage = createPage(
  () => import('@pages/backoffice/company-manager/authorization/detail/authorization-detail-page')
)

export const CollaboratorsPage = createPage(
  () => import('@pages/backoffice/company-manager/collaborators/list/collaborators-page')
)

export const GroupsPage = createPage(
  () => import('@pages/backoffice/company-manager/groups/groups-page')
)

// ============================================
// INTERNAL COMPANY MANAGER
// ============================================

export const CompanyCreatePage = createPage(
  () => import('@pages/backoffice/internal-company-manager/company/company-create-page')
)

export const BatchDisableUserPage = createPage(
  () =>
    import('@pages/backoffice/internal-company-manager/batch-disable-user/batch-disable-user-page')
)

export const InvoicePage = createPage(
  () => import('@pages/backoffice/internal-company-manager/invoice/invoice-event-list-page')
)

export const InvoiceDetailPage = createPage(
  () => import('@pages/backoffice/internal-company-manager/invoice/invoice-event-detail-page')
)

export const CompaniesListPage = createPage(
  () => import('@pages/backoffice/internal-company-manager/company/companies-list-page')
)

export const CompanyDetailPage = createPage(
  () => import('@pages/backoffice/internal-company-manager/company/company-detail-page')
)

export const PartnerDetailPage = createPage(
  () => import('@pages/backoffice/internal-company-manager/partner/partner-detail-page')
)

export const FitScorePage = createPage(
  () => import('@pages/backoffice/internal-company-manager/fit-score/fit-score-page')
)

// ============================================
// SYSTEM MANAGER
// ============================================

export const SystemConfigurationsPage = createPage(
  () => import('@pages/backoffice/system-manager/system-configurations-page')
)
